import { OfferHighlight } from "components/OfferHighlights/OfferHighlights";
import {
  ExclusiveOfferFeatureFragment,
  LocationFilterFragment,
  Maybe,
  OfferPerPromoQuery
} from "types/graphql-types";

import { matchesAny } from "../../utils/localization/geolocation";
import { LocalizedPromo } from "./types";
import { isPresent } from "src/utils/checks";
import { Geolocation } from "src/utils/localization/geolocation/geolocation";
import { RemotePromos } from "src/ssc-api/useRemotePromos";

export const defaultLocalizedPromo: LocalizedPromo = {
  title: undefined,
  highlightsTitle: undefined,
  offerHighlights: [],
  termsAndConditionsFootnote: undefined,
  data: undefined
};

type FilterableContent = {
  conditionFilters?: Maybe<Array<Maybe<string>>>;
  locationFilters?: (LocationFilterFragment | undefined)[];
};

export const matchesLocation =
  <T extends FilterableContent>(geolocation?: Geolocation) =>
  (content: T | undefined): boolean =>
    matchesAny(content?.locationFilters, geolocation);

const filterContent = <T>(
  geolocation: Geolocation | undefined,
  content:
    | ((FilterableContent & { content?: Maybe<T> }) | undefined)[]
    | undefined
): T | undefined => (content || []).find(matchesLocation(geolocation))?.content;

const toOfferHighlight = (
  highlight: ExclusiveOfferFeatureFragment
): OfferHighlight => ({
  name: highlight.name?.localized,
  description: highlight.description?.localized,
  icon: highlight.icon
});

export const filterHighlights = (
  geolocation?: Geolocation,
  offerHighlights?: ExclusiveOfferFeatureFragment[]
): OfferHighlight[] =>
  (offerHighlights || [])
    .filter(matchesLocation(geolocation))
    .map(toOfferHighlight);

export const offerPerPromoToLocalizedOffer =
  (offer: OfferPerPromoQuery["offer"], geolocation: Geolocation | undefined) =>
  (offerData: RemotePromos[number] | undefined): LocalizedPromo => {
    const offerHighlights = filterHighlights(
      geolocation,
      offer?.features?.filter(isPresent)
    );
    const termsAndConditionsFootnote = filterContent(
      geolocation,
      offer?.termsAndConditionsFootnote
    );

    return {
      title: offer?.title,
      highlightsTitle: offer?.featureTitle,
      offerHighlights,
      termsAndConditionsFootnote,
      data: offerData
    };
  };
